package com.sweetlime.bingeamigo.model

import dev.gitlive.firebase.firestore.Timestamp
import kotlinx.serialization.Serializable

@Serializable
data class AppNotification(
    val id: String = "",
    val type: String = "",
    val title: String = "",
    val body: String = "",
    val read: Boolean = false,
    val createdAt: Timestamp? = null,
    val senderId: String? = null,
    val senderUsername: String? = null,
    val senderAvatar: String? = null,
    val entityId: String? = null
) {
    companion object {
        const val TYPE_FOLLOW = "follow"
        const val TYPE_LIKE = "like"
        const val TYPE_NEW_EPISODE = "new_episode"
        const val TYPE_LEVEL_UP = "level_up"
    }
}